module.exports = "<div class=\"mb-3\">\n  <ng-content></ng-content>\n</div>\n"